// FittingBox Setup

var params = {
  apiKey: "aGLQUpUgSgx00MR2z3ZuDvqiMZ2qTXGdkpBlCyJf",
  onStopVto: hide,
  onIssue: (data) => {
    console.log(data);
  },
};

const popup = document.getElementById("popup-container");
const fitmix = document.getElementById("fitmix-container");
let fittingboxTexts = {};

async function instantiateFittingBox(texts) {
  fittingboxTexts = texts;
  await new Promise((resolve) => {
    window.fitmixInstance = FitMix.createWidget(
      "fitmix-container",
      params,
      function () {
        console.log("VTO module is ready.");
        resolve(); // Resolve when the callback is triggered
      }
    );
  });
}

function hide() {
  popup.style.display = "none";
  popup.classList.remove("dim-background");
}

function show() {
  popup.style.display = "block";
  popup.classList.add("dim-background");
}

function openVto(uid) {
  window.fitmixInstance.setFrame(uid);
  fitmixInstance.startVto("live");
  show();
}

function openVtoWithoutSelection() {
  openVto("");
}

function stopVto() {
  fitmixInstance.stopVto();
  hide();
}

async function getAvailability(idTable) {
  // Put your apiKey as an environment Variable
  const apiKey = "aGLQUpUgSgx00MR2z3ZuDvqiMZ2qTXGdkpBlCyJf";
  const url = `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${apiKey}&uidList=${idTable.join(
    ","
  )}`;

  const result = await fetch(url);
  if (result.ok) {
    return result.json();
  }

  throw new Error("an error occured");
}

// Popup

function createPopupTemplate() {
  const btnGenderMale = document.getElementById("btn-gender-male");
  const btnGenderFemale = document.getElementById("btn-gender-female");
  const closeButton = document.getElementById("fbx-popup-close-button");

  btnGenderMale.addEventListener("click", () => {
    btnGenderMale.classList.add("selected");
    btnGenderFemale.classList.remove("selected");
    const data = { gender: "m" };
    fitmixInstance.setUserInfo(data);
    openVto();
  });
  btnGenderFemale.addEventListener("click", () => {
    btnGenderMale.classList.remove("selected");
    btnGenderFemale.classList.add("selected");
    const data = { gender: "f" };
    fitmixInstance.setUserInfo(data);
    openVto();
  });

  closeButton.addEventListener("click", () => {
    stopVto();
    resetCarouselItems();
  });
}

function createPopupThumbnail(product, model) {
  const carrouselContainerElement = document.createElement("div");
  const popupCarrouselElement = document.getElementById("fbx-popup-carrousel");
  const productImageElement = document.createElement("img");
  const productButtonElement = document.createElement("button");

  carrouselContainerElement.classList.add("fbx-popup-carrousel-product");
  productButtonElement.classList.add("button");
  productImageElement.src = model.featured_image
    ? model.featured_image.src
    : "";
  productImageElement.alt = model.name;
  productButtonElement.textContent = fittingboxTexts["try"];
  var dataName = model.name;
  productButtonElement.setAttribute("data-name", dataName);

  carrouselContainerElement.addEventListener("click", () => {
    window.fitmixInstance.setFrame(cleanSku(model.sku));
    selectCarouselItem(model.name, product.url, forgePrice(model.price));
  });

  carrouselContainerElement.append(productImageElement, productButtonElement);
  popupCarrouselElement.appendChild(carrouselContainerElement);
}

function selectCarouselItemAndHideOtherItems(element) {
  selectCarouselItem(
    element.dataset.name,
    element.dataset.url,
    forgePrice(element.dataset.price)
  );
  hiderOtherItems(element.dataset.name);
}

function selectCarouselItem(name, url, price) {
  const productTitleElement = document.getElementById("prod-title-elem");
  const productRedirectElement = document.getElementById("redirect-button");

  productRedirectElement.classList.add("button");

  productTitleElement.textContent = cleanString(name);
  productRedirectElement.href = url;
  productRedirectElement.innerHTML = `${fittingboxTexts["see"]} - ${price}€`;
  productRedirectElement.style.display = "block";

  const items = document.querySelectorAll(".fbx-popup-carrousel-product");
  if (items) {
    items.forEach((item) => {
      if (item.children[0].getAttribute("alt") == name) {
        item.classList.add("selected");
      } else {
        item.classList.remove("selected");
      }
    });
  }
}

function hiderOtherItems(name) {
  const items = document.querySelectorAll(".fbx-popup-carrousel-product");
  if (items) {
    let glassesName = cleanString(name).split(" - ")[0];
    items.forEach((item) => {
      if (item.children[0].getAttribute("alt").startsWith(glassesName)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }
}

function resetCarouselItems() {
  const productTitleElement = document.getElementById("prod-title-elem");
  const productRedirectElement = document.getElementById("redirect-button");

  productTitleElement.textContent = fittingboxTexts["select"];
  productRedirectElement.style.display = "none";

  const items = document.querySelectorAll(".fbx-popup-carrousel-product");
  if (items) {
    items.forEach((item) => {
      item.classList.remove("selected");
      item.style.display = "block";
    });
  }
}

// Product List

async function processProduct(product) {
  const colorVariants = Object.groupBy(product.variants, ({ options }) => {
    return options[product.colorPosition];
  });

  const variantSkus = Object.values(colorVariants).map((colorVariant) => {
    return colorVariant[0].sku != null ? cleanSku(colorVariant[0].sku) : "";
  });

  const resultvariants = await getAvailability(variantSkus);

  const availableVariants = resultvariants.filter(
    (variant) => variant.available
  );

  availableVariants.forEach((model) => {
    const matchingModel = product.variants.find(
      (variant) => variant.sku.includes(model.uid) // Vérifie si le sku contient model.uid
    );
    matchingModel.uid = cleanSku(matchingModel.sku);

    createPopupThumbnail(product, matchingModel);
    displayButtonOnProductCard(product, matchingModel);
  });
}

async function displayButtonOnProductCard(product, matchingModel) {
  let imageToAppendElements = document.querySelectorAll(
    `.variant-${matchingModel.sku}`
  );

  if (!imageToAppendElements.length) {
    const product_skus = product.variants[0].sku.split("-");
    let product_sku = cleanSku(product_skus[0]);
    if (product_skus[1] == "SP") {
      product_sku = `${product_skus[0]}-${product_skus[1]}`;
    }
    imageToAppendElements = document.querySelectorAll(
      `.product-${product_sku}`
    );
  }

  if (!imageToAppendElements.length) return;

  imageToAppendElements.forEach((item) => {
    if (item.querySelector(".fbx-start-button-home") == null) {
      item.style.position = "relative";
      item.appendChild(createButton(product, matchingModel));
    }
  });
}

function createButton(product, matchingModel) {
  let tryOnButton = document.createElement("button");
  tryOnButton.innerText = fittingboxTexts["try_them"];

  tryOnButton.classList.add("fbx-start-button-home", "button");
  tryOnButton.setAttribute("data-uid", matchingModel.uid || "");
  tryOnButton.setAttribute("data-name", matchingModel.name); // Utiliser le nom du variant correspondant
  tryOnButton.setAttribute("data-price", matchingModel.price);
  tryOnButton.setAttribute("data-url", product.url);

  // Create a new SVG element
  let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

  // Set attributes of the SVG element
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  svg.setAttribute("fill", "white");
  svg.setAttribute("viewBox", "0 0 576 512");
  svg.setAttribute("width", "14");
  svg.setAttribute("height", "14");

  // Create a new path element
  let path = document.createElementNS("http://www.w3.org/2000/svg", "path");

  // Set the path data
  path.setAttribute(
    "d",
    "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
  );

  // Append the path to the SVG element
  svg.appendChild(path);

  // Append the SVG element to the button
  tryOnButton.prepend(svg);

  return tryOnButton;
}

function addListenerOnButtons() {
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".fbx-start-button-home");
    if (!button) return;

    selectCarouselItemAndHideOtherItems(button);
    openVto(button.dataset.uid);
  });
}

// Product Page

function insertEmptyButton() {
  // Do not add it directly in buy-buttons div or it will trigger event to add to cart too
  const target = document.querySelector(
    '.product-info__block-item[data-block-type="buy-buttons"]'
  );

  if (!target) {
    console.log("Target element not found in the DOM");
    return;
  }
  // Create the button
  const button = document.createElement("button");
  button.classList.add("fbx-try-button", "button", "w-full");
  button.innerText = fittingboxTexts["try_them"];
  button.style.display = "none";

  // Insert the button after the target element
  target.insertAdjacentElement("afterend", button);

  button.addEventListener("click", (e) => {
    selectCarouselItemAndHideOtherItems(e.target);
    openVto(e.target.dataset.uid);
  });
}

/**
 * Update the button into the DOM after the specified target element
 * @param {string} uid - The product ID
 **/
async function updateButton(variant, productTitle) {
  // Find the target element
  const button = document.querySelector(".fbx-try-button");

  const uid = await checkVariantAvailability(variant);

  if (uid) {
    button.style.display = "block";
    button.setAttribute("data-uid", uid); // Set the product ID as a data attribute

    button.setAttribute("data-name", `${productTitle} - ${variant.title}`); // Utiliser le nom du variant correspondant
    button.setAttribute("data-model", `${productTitle}`);
    button.setAttribute("data-price", variant.price);
    button.setAttribute("data-url", variant.url);
  } else {
    button.style.display = "none";
  }
}

async function checkVariantAvailability(variant) {
  let idTable = [cleanSku(variant.sku)];

  try {
    const availabilityResult = await getAvailability(idTable);
    return availabilityResult.length && availabilityResult[0].available
      ? availabilityResult[0].uid
      : null;
  } catch (err) {
    console.log("Error fetching availability", err);
  }
}

// Menu

function addListenerOnMenuButton() {
  const navBarButtonElements = document.querySelectorAll(
    'a[href*="/essayage-virtuel"]'
  );

  navBarButtonElements.forEach((element) =>
    element.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      openVtoWithoutSelection();
    })
  );
}

// Utils

function cleanString(input) {
  return input.replace(/-\s*\d+\s*\//, "/");
}

function cleanSku(sku) {
  return sku.replace(/-\d+$/, "");
}

function forgePrice(price) {
  return `${(price / 100).toFixed(2).replace(".", ",")}`;
}
